import { FieldTypes } from '../constants/FieldTypes'
import {
  CheckboxField,
  DateField,
  DropdownField,
  FieldMap,
  MultipleSelectField,
  TextAreaField,
  TextField,
} from '../types/forms/fields'
import { notesField } from './shared'

export const deliveryDateField: DateField = {
  type: FieldTypes.DATE,
  placeholder: 'Date of Delivery',
  maxDate: 'now',
}

export const newbornSexField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Sex of Newborn',
  options: [
    {
      id: 'M',
      text: 'Male',
    },
    {
      id: 'F',
      text: 'Female',
    },
  ],
}

export const deliveryLocationField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Delivery Location',
  options: [
    {
      id: 'home',
      text: 'Home',
    },
    {
      id: 'hospital',
      text: 'Hospital',
    },
    {
      id: 'birthing-center',
      text: 'Birthing Center',
    },
    {
      id: 'other',
      text: 'Other',
    },
  ],
}
// 'nsvd' | 'cSection' | 'breech' | 'vacuum' | 'forceps'
export const deliveryLocationOtherField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Other Delivery Location',
  condition: v => v?.deliveryLocation === 'other',
}
export const deliveryTypesField: MultipleSelectField = {
  type: FieldTypes.MULTIPLE_SELECT,
  placeholder: 'Delivery Types',
  options: [
    { id: 'nsvd', text: 'NSVD' },
    { id: 'cSection', text: 'C-Section' },
    { id: 'breech', text: 'Breech' },
    { id: 'vacuum', text: 'Vacuum' },
    { id: 'forceps', text: 'Forceps' },
  ],
}

export const isTransferField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Transfer',
  inputType: 'switch',
}
export const newbornFnameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Newborn First Name',
  optional: true,
}
export const newbornLnameField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Newborn Last Name',
  optional: true,
}
export const newbornWeightField: FieldMap = {
  name: 'Newborn Weight',
  optional: true,
  children: {
    lb: {
      type: FieldTypes.NUMBER,
      placeholder: 'Pounds',
      precision: 0,
      min: 0,
      row: {
        flex: 1,
        index: 0,
      },
    },
    oz: {
      type: FieldTypes.NUMBER,
      placeholder: 'Ounces',
      precision: 2,
      min: 0,
      row: {
        flex: 1,
        index: 0,
      },
    },
  },
}

export const reportDeliveryField: FieldMap = {
  name: 'Report Delivery',
  children: {
    date: deliveryDateField,
    newbornSex: newbornSexField,
    newbornFname: {
      ...newbornFnameField,
      optional: true,
      row: {
        flex: 1,
        index: 0,
      },
    },
    newbornLname: {
      ...newbornLnameField,
      optional: true,
      row: {
        flex: 1,
        index: 0,
      },
    },
    newbornWeight: newbornWeightField,
    deliveryLocation: deliveryLocationField,
    deliveryLocationOther: deliveryLocationOtherField,
    deliveryTypes: deliveryTypesField,
    lactationClassCompleted: {
      type: FieldTypes.CHECKBOX,
      placeholder: 'Lactation Class Completed',
      row: { flex: 1, index: 1 },
    } as CheckboxField,
    lactationClassCompletedOn: {
      type: FieldTypes.DATE,
      placeholder: 'Date Completed',
      maxDate: 'now',
      condition: v => !!v?.lactationClassCompleted,
      row: { flex: 1, index: 1 },
    } as DateField,
    lactationProblem: {
      type: FieldTypes.CHECKBOX,
      placeholder: 'Lactation Problem',
      row: { flex: 1, index: 2 },
    } as CheckboxField,
    lactationProblemOn: {
      type: FieldTypes.DATE,
      placeholder: 'Lactation Problem Date',
      maxDate: 'now',
      condition: v => !!v?.lactationProblem,
      row: { flex: 1, index: 2 },
    } as DateField,
    lactationProblemNotes: {
      type: FieldTypes.TEXTAREA,
      placeholder: 'Describe issue, include total time for visit and MDM level (Low or Medium)',
      optional: true,
      condition: v => !!v?.lactationProblem,
    } as TextAreaField,
    rhogamAdministration: {
      type: FieldTypes.CHECKBOX,
      placeholder: 'Rhogam Administration',
      row: { flex: 1, index: 3 },
    } as CheckboxField,
    rhogamAdministrationOn: {
      type: FieldTypes.DATE,
      placeholder: 'Rhogam Administration Date',
      maxDate: 'now',
      condition: v => !!v?.rhogamAdministration,
      row: { flex: 1, index: 3 },
    } as DateField,
    summary: { ...notesField, placeholder: 'Summary', withDotPhrases: true },
  },
}
